module.exports = __webpack_public_path__ + "img/pexels-artempodrez-5716031.48953382.png";